import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import { Item, Grid, Icon } from "semantic-ui-react";
import { Paginate } from "../../components";
import HomeSalePagination from "../../components/Pagination/HomeSalePagination";
import { Iconstyle, Iconstylered } from "./element";

import { useMediaQuery } from "react-responsive";
import { Carousel } from "react-responsive-carousel";

var humanFormat = require("human-format");

const SaleHomeList = ({
  cardData,
  href,
  save,
  heart,
  active,
  prev,
  getData,
  checkIfImageExistshome,
  pageSize = 3, // Default to 3 items per page, can be overridden
  ...props
}) => {
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Check for mobile screen
  let data = cardData.length;
  let page_size = pageSize; // Use the pageSize prop
  let indexdata = (active - 1) * page_size;

  const renderItem = (item, index) => {
    let finaladd;
    let finaladdsec;
    let bathtotal;
    if (item.UnparsedAddress) {
      // let add = item.UnparsedAddress.split(",");

      // if (add.length > 3) {
      //   finaladd = add[2];
      //   finaladdsec = add[0] + ", " + add[1] + " " + add[3];
      // } else {
      //   finaladd = item.UnparsedAddress;
      //   finaladdsec = "";
      // }

      finaladd =
        item.UnparsedAddress +
        ", " +
        item.City.replace(/([a-z])([A-Z])/g, "$1 $2") +
        ", " +
        item.StateOrProvince +
        ", " +
        item.PostalCode;
    }
    if (item.BathroomsHalf) {
      bathtotal = item.BathroomsFull + item.BathroomsHalf * 0.5;
    } else {
      bathtotal = item.BathroomsFull;
    }
    let price;
    if (item.MlsStatus === "Sold") {
      if (Number.isInteger(item.ClosePrice)) {
        price = "$" + humanFormat(item.ClosePrice).replace(/\s/g, "");
      } else {
        price = item.ClosePrice;
      }
    } else {
      if (Number.isInteger(item.ListPrice)) {
        price = "$" + humanFormat(item.ListPrice).replace(/\s/g, "");
      } else {
        price = item.ListPrice;
      }
    }
    let media;
    if (item.SourceId) {
      // if (checkIfImageExistshome(item.ThumbnailUrl)) {
      media = item.ThumbnailUrl;
      // } else if (
      //   checkIfImageExistshome(item.ThumbnailUrl) !== undefined
      // ) {
      //   media =
      //     process.env.NEXT_PUBLIC_CDN_ID +
      //     "static/images/homedefault.jpg";
      // }
    } else {
      if (item.Media && item.Media.length > 0) {
        let url = item.Media[0].MediaURL;
        let finaloutput = "";
        //media = url;

        //if (checkIfImageExistshome(url)) {
        media = url;
        // } else if (checkIfImageExistshome(url) !== undefined) {
        //   media =
        //     process.env.NEXT_PUBLIC_CDN_ID +
        //     "static/images/homedefault.jpg";
        // }
      } else {
        media =
          process.env.NEXT_PUBLIC_CDN_ID + "static/images/homedefault.jpg";
      }
    }

    if (!isMobile) {
      return (
        <Item key={index}>
          <div className="ui fluid image">
            <Link
              href={"/DetailsListing/?id=" + item.ListingKeyNumeric}
              title={item.ListingKeyNumeric}
              style={{ cursor: "pointer" }}
              target="_blank"
            >
              {/* <a
                style={{ cursor: "pointer" }}
                target="_blank"
                title={item.ListingKeyNumeric}
              > */}
              <img
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/homedefault.jpg";
                }}
                style={{ height: "300px" }}
                src={media}
                alt={finaladd}
                title={finaladd}
              />
              {/* </a> */}
            </Link>
            <div
              style={{
                position: "absolute",
                bottom: 0,
                width: "100%",
                height: "auto",
                color: "white",

                // opacity: 0.6
              }}
              className="home_list"
            >
              <Link
                href={"/DetailsListing/?id=" + item.ListingKeyNumeric}
                title={item.ListingKeyNumeric}
                target="_blank"
                style={{ color: "#FFF" }}
              >
                {/* <a
                  target="_blank"
                  style={{ color: "#FFF" }}
                  title={item.ListingKeyNumeric}
                > */}
                <Grid style={{ padding: "0px 10px" }}>
                  <Grid.Column width={9}>
                    <Grid.Row>
                      <span className="home_price_main">
                        <strong>{price}</strong>
                      </span>
                    </Grid.Row>
                    <Grid.Row>
                      {finaladd}
                      <br />
                      {finaladdsec}
                    </Grid.Row>
                    {/*<Grid.Row>{item.address.city}, {item.address.state} {item.address.zip}</Grid.Row>*/}
                  </Grid.Column>
                  <Grid.Column width={7}>
                    <Grid divided style={{ padding: 10, textAlign: "center" }}>
                      <Grid.Column width={5}>
                        <Grid.Row>
                          {item.BedroomsTotal ? item.BedroomsTotal : "-"}
                        </Grid.Row>
                        <Grid.Row>Beds</Grid.Row>
                      </Grid.Column>
                      <Grid.Column width={5}>
                        <Grid.Row>{bathtotal ? bathtotal : "-"}</Grid.Row>
                        <Grid.Row>Baths</Grid.Row>
                      </Grid.Column>
                      <Grid.Column width={6}>
                        <Grid.Row>
                          {item.LivingArea ? item.LivingArea : "-"}
                        </Grid.Row>
                        <Grid.Row>sq.ft.</Grid.Row>
                      </Grid.Column>
                    </Grid>
                  </Grid.Column>
                </Grid>
                {/* </a> */}
              </Link>
            </div>
            <div
              style={{
                position: "absolute",
                top: 0,
                width: "100%",
                height: "auto",
              }}
            >
              <Grid style={{ padding: 10 }}>
                <Grid.Column width={9}>
                  {/*<Grid.Row style={{backgroundColor: 'green', textAlign: 'center', color: 'white'}}>Open SUN 1PM to*/}
                  {/*4 PM</Grid.Row>*/}
                </Grid.Column>
                <Grid.Column floated="right">
                  <Grid.Row>
                    {heart[item.ListingKeyNumeric] ? (
                      <span onClick={(e) => save(item.ListingKeyNumeric, item)}>
                        <Icon
                          size="big"
                          name="heart"
                          //color="#c02e26"
                          style={Iconstylered}
                        />
                      </span>
                    ) : (
                      <span onClick={(e) => save(item.ListingKeyNumeric, item)}>
                        <Icon
                          size="big"
                          name="heart outline"
                          style={Iconstyle}
                        />
                      </span>
                    )}
                  </Grid.Row>
                </Grid.Column>
              </Grid>
            </div>
          </div>
        </Item>
      );
    } else {
      return (
        <div key={index}>
          <div className="ui fluid image">
            <Link
              href={"/DetailsListing/?id=" + item.ListingKeyNumeric}
              title={item.ListingKeyNumeric}
              style={{ cursor: "pointer" }}
              target="_blank"
            >
              {/* <a
                style={{ cursor: "pointer" }}
                target="_blank"
                title={item.ListingKeyNumeric}
              > */}
              <img
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/homedefault.jpg";
                }}
                style={{ height: "300px" }}
                src={media}
                alt={finaladd}
                title={finaladd}
              />
              {/* </a> */}
            </Link>
          </div>
          <div
            style={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              height: "auto",
              color: "white",
              left: 0,
              // opacity: 0.6
            }}
            className="home_list"
          >
            <Link
              href={"/DetailsListing/?id=" + item.ListingKeyNumeric}
              title={item.ListingKeyNumeric}
              target="_blank"
              style={{ color: "#FFF" }}
            >
              {/* <a
                target="_blank"
                style={{ color: "#FFF" }}
                title={item.ListingKeyNumeric}
              > */}
              <Grid style={{ padding: "0px 5px", textAlign: "left" }}>
                <Grid.Column width={9}>
                  <Grid.Row>
                    <span className="home_price_main">
                      <strong>{price}</strong>
                    </span>
                  </Grid.Row>
                  <Grid.Row>
                    {finaladd}
                    <br />
                    {finaladdsec}
                  </Grid.Row>
                  {/*<Grid.Row>{item.address.city}, {item.address.state} {item.address.zip}</Grid.Row>*/}
                </Grid.Column>
                <Grid.Column width={7}>
                  <Grid divided style={{ padding: 10, textAlign: "center" }}>
                    <Grid.Column width={5}>
                      <Grid.Row>
                        {item.BedroomsTotal ? item.BedroomsTotal : "-"}
                      </Grid.Row>
                      <Grid.Row>Beds</Grid.Row>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Grid.Row>{bathtotal ? bathtotal : "-"}</Grid.Row>
                      <Grid.Row>Baths</Grid.Row>
                    </Grid.Column>
                    <Grid.Column width={6}>
                      <Grid.Row>
                        {item.LivingArea ? item.LivingArea : "-"}
                      </Grid.Row>
                      <Grid.Row>sq.ft.</Grid.Row>
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
              </Grid>
              {/* </a> */}
            </Link>
          </div>
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
            }}
          >
            <Grid style={{ padding: 10 }}>
              <Grid.Column floated="right">
                <Grid.Row>
                  {heart[item.ListingKeyNumeric] ? (
                    <span onClick={(e) => save(item.ListingKeyNumeric, item)}>
                      <Icon
                        size="big"
                        name="heart"
                        //color="#c02e26"
                        style={Iconstylered}
                      />
                    </span>
                  ) : (
                    <span onClick={(e) => save(item.ListingKeyNumeric, item)}>
                      <Icon size="big" name="heart outline" style={Iconstyle} />
                    </span>
                  )}
                </Grid.Row>
              </Grid.Column>
            </Grid>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="sale_list">
      <div className="home_list_main" style={{ paddingLeft: 0 }}>
        {isMobile ? (
          <Item.Group>
            <Carousel
              showThumbs={false}
              autoPlay={false}
              showIndicators={false}
              onClickItem={(index, item) => {
                const selectedItem = cardData[index];
                if (selectedItem) {
                  const url = `/DetailsListing/?id=${selectedItem.ListingKeyNumeric}`;
                  window.open(url, "_blank");
                }
              }}
            >
              {cardData.map(renderItem)}
            </Carousel>
          </Item.Group>
        ) : (
          <>
            <Item.Group>
              {cardData.slice(indexdata, indexdata + page_size).map(renderItem)}
            </Item.Group>
            {data > 0 && (
              // Use custom pagination for "sale" id (Homes for Sale section)
              props.id === "sale" ? (
                <HomeSalePagination
                  length={data}
                  prev={prev}
                  active={active}
                  perpage={page_size}
                  {...props}
                />
              ) : (
                <Paginate length={data} prev={prev} active={active} {...props} />
              )
            )}
          </>
        )}
      </div>
    </div>
  );
};

SaleHomeList.propTypes = {
  cardData: PropTypes.array.isRequired,
  save: PropTypes.func.isRequired,
  heart: PropTypes.object.isRequired,
  active: PropTypes.number.isRequired,
  prev: PropTypes.func.isRequired,
};

export default SaleHomeList;
